// extracted by mini-css-extract-plugin
export default {"layout":"common-layout_layout__36bVU","header":"common-layout_header__Szqhm","content":"common-layout_content__GsHDf"};